import CartonStatus from "./CartonStatus"

const StatusOption =[
    { value: CartonStatus.WaitAdmin, label: 'Wait for Admin Service' },
    { value: CartonStatus.Inprogress, label: 'On Going' },
    { value: CartonStatus.Done, label: 'Completed Service' },
    { value: CartonStatus.Reject, label: 'Rejected' }
  ]

export default StatusOption